const query = (id, isPreview) => `{
  navigationItem(id: "${id}", preview: ${isPreview}) {
    label
    variant
    link {
      title
      label
      url
    }
    dropdownItemsCollection {
      items {
        ... on NavigationItem {
          label
          link {
            title
            label
            url
          }
          dropdownItemsCollection(limit: 15) {
            items {
              ... on NavigationItem {
                label
                displayName
                variant
                link {
                  title
                  label
                  url
                }
                subLinksCollection(limit: 5) {
                  items {
                    ... on Link {
                      title
                      label
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
  `
  module.exports = { query }